module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "desktop-wrapper"
  }, [_c('desktop-header', {
    attrs: {
      "calname": _vm.calInfo.name,
      "schoolname": _vm.schoolName
    },
    on: {
      "locale": _vm.setLocale,
      "print": _vm.print
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('week-selector', {
    attrs: {
      "startDate": _vm.calInfo.start_date,
      "endDate": _vm.calInfo.end_date,
      "date": _vm.date
    },
    on: {
      "changed": _vm.setDate
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "printCalendar"
    }
  }, [_c('h2', {
    staticClass: "only-print print-calendar-name"
  }, [_vm._v(_vm._s(_vm.calInfo.name))]), _vm._v(" "), _c('div', {
    staticClass: "box cal-container"
  }, [_c('div', {
    staticClass: "cal-container__header"
  }, [_c('div', {
    staticClass: "cal-container__header--left"
  }, [_c('h3', [_vm._v(_vm._s(_vm.showDate))])]), _vm._v(" "), _c('div', {
    staticClass: "cal-container__header--right"
  }, [_c('div', {
    staticClass: "cal-toggle no-print",
    on: {
      "click": function($event) {
        _vm.isCalNoBgColors = !_vm.isCalNoBgColors
      }
    }
  }, [_c('label', {
    staticClass: "cal-toggle__label"
  }, [_vm._v(_vm._s(_vm.$t('vue2.public_calendar.black_white')))]), _vm._v(" "), _c('AppToggle', {
    attrs: {
      "allowChanges": false,
      "propOn": _vm.isCalNoBgColors
    }
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "do-bttn no-print",
    class: {
      'bttn--disabled': !_vm.isNotThisWeek
    },
    on: {
      "click": _vm.setToday
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('repitition.today')) + "\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "do-bttn icon-arrow-left4 no-print",
    on: {
      "click": _vm.prevWeek
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "do-bttn icon-arrow-right4 no-print",
    on: {
      "click": _vm.nextWeek
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "d-calendar__calendar__container",
    class: {
      'd-calendar__calendar__container--print-mode': _vm.isCalendarInPrintMode
    }
  }, [_c('DCalendar', {
    key: _vm.activeCalendarDate + '_' + _vm.locale,
    attrs: {
      "isEditable": false,
      "isCalendarInPrintMode": _vm.isCalendarInPrintMode,
      "isShowWeekends": _vm.isShowWeekends,
      "isCalNoBgColors": _vm.isCalNoBgColors,
      "startTime": _vm.startTime,
      "endTime": _vm.endTime,
      "date": _vm.activeCalendarDate,
      "events": _vm.allEvents,
      "calendarId": _vm.calId,
      "calendarName": _vm.calInfo.name || '',
      "isEventsClickable": true,
      "isLoadingEvents": _vm.isLoading,
      "localeOverride": _vm.locale
    },
    on: {
      "onEventClick": _vm.showEvent
    }
  })], 1)]), _vm._v(" "), _c('weekplan', {
    attrs: {
      "locale": _vm.locale,
      "calId": _vm.calId,
      "date": _vm.date,
      "events": _vm.allEvents,
      "calview": 'agendaWeek'
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3b657902!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/public/Desktop/DesktopView.vue
// module id = 1868
// module chunks = 1